import { useEffect, useState } from 'react';
import useSWR from 'swr';
import { ShoppingBag } from 'lucide-react';
import { API } from '@/lib/api';

const fetcher = (url) => fetch(`${API}${url}`).then((r) => r.ok ? r.json() : []);

function timeAgo(iso) {
  if (!iso) return 'just now';
  const then = new Date(iso).getTime();
  const min = Math.max(1, Math.round((Date.now() - then) / 60000));
  if (min < 60) return `${min} min ago`;
  const hr = Math.round(min / 60);
  if (hr < 24) return `${hr} hr ago`;
  const days = Math.round(hr / 24);
  return `${days} day${days === 1 ? '' : 's'} ago`;
}

export default function JustOrderedTicker() {
  const { data: orders = [] } = useSWR('/shop/recent-orders', fetcher, { refreshInterval: 60_000 });
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    if (orders.length < 2) return undefined;
    const t = setInterval(() => setIdx((i) => (i + 1) % orders.length), 6000);
    return () => clearInterval(t);
  }, [orders.length]);

  if (!orders?.length) return null;
  const o = orders[idx] || orders[0];
  const qty = o.unit === 'kg' ? `${o.quantity}kg` : `${o.quantity}×`;

  return (
    <div
      data-testid="just-ordered-ticker"
      className="border-y border-white/10 bg-black/40 py-2.5"
    >
      <div className="max-w-screen-2xl mx-auto px-6 sm:px-10 lg:px-16 flex items-center justify-center gap-3 text-[11px] uppercase tracking-[0.22em] text-white/60">
        <span className="inline-flex h-2 w-2 rounded-full bg-emerald-400 animate-pulse shrink-0" />
        <ShoppingBag size={12} className="text-[var(--mw-primary)] shrink-0" />
        <span className="truncate">
          <span className="text-white font-medium normal-case tracking-normal">{o.first_name}</span>
          {o.suburb && (
            <span className="text-white/50 normal-case tracking-normal"> in <span className="text-white font-medium">{o.suburb}</span></span>
          )}
          <span className="mx-1.5 normal-case tracking-normal">just ordered</span>
          <span className="text-white font-medium normal-case tracking-normal">{qty} {o.product_name}</span>
          <span className="ml-2 text-white/40">· {timeAgo(o.created_at)}</span>
        </span>
      </div>
    </div>
  );
}
